import { render, staticRenderFns } from "./ArchiveLegend.vue?vue&type=template&id=3ca749ac&scoped=true&"
import script from "./ArchiveLegend.vue?vue&type=script&lang=js&"
export * from "./ArchiveLegend.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveLegend.vue?vue&type=style&index=0&id=3ca749ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca749ac",
  null
  
)

export default component.exports